app.directive('confirmation', function ($mdDialog, $sce) {
	return {
		restrict: 'A',
		scope: {
			cnBefore:"=",//akcja przed jesli zwraca false modal nie wyskakuje
			cnAccept: '=', //akcja na potwierdzenie
			cnReject: '=', //akcja na odrzucenie
			cnArgument: '=', //dodatkowy argument do akcji potwierdzenie
			cnTitle: '@', //tytuł na modala
			cnMessage: '@', //wiadomosc na modalu
		},
		link: confirmationLink
	};
	function confirmationLink(scope, element) {
		var modal = null;

		init();
		function init() {
			$(element).click(onClick);
		}
		function onClick() { 
			//function before
			if (typeof scope.cnBefore==='function'){
				return scope.cnBefore(scope.cnArgument)?openModal():false;
			} else if(typeof scope.cnBefore==='boolean'){
				return scope.cnBefore?openModal():false;
			} else return openModal();

		};

		function openModal() {
			$mdDialog.show({
				templateUrl: '/assets/js/angular/components/directives/confirmation/confirmation.html',
				controller: modalCtrl,
				locals: {
					message: scope.cnMessage,
					title: scope.cnTitle
				}
			}).then(commit, cancel);
			
		};
		
		function modalCtrl($scope, $mdDialog, locals) {
			$scope.title = locals.title;
			$scope.message = locals.message;
			
			$scope.commit= function() {
				$mdDialog.hide();
			};

			$scope.cancel= function() {
				$mdDialog.cancel();
			};
			
		};

		function commit() {
			if (_.isFunction(scope.cnAccept)) {
				scope.cnAccept(scope.cnArgument);
			}
		};

		function cancel() {
			if (_.isFunction(scope.cnReject)) {
				scope.cnReject(scope.cnArgument);
			}
		};
	}

});